import React from 'react'
import Param from '../store/param';

import FormSetup from './formSetup';
import FormAlign from './formAlign';
import FormBaseShape from './formBaseShape';
import FormCompress from './formCompress';

import FormTrim1 from './formTrim1';
import FormTrim2 from './formTrim2';
//import FormAssemble from './formAssemble';
import FormAssembleFd from './formAssembleFd';
import FormOutput from './formOutput';

const FormFinal = () => {
  const activeStep = Param.Get('activeStep');


  switch (activeStep) {
    case 0:
      return <FormSetup/>;
    case 1:
      return <FormAlign/>;
    case 2:
      return <FormBaseShape/>;
    case 3:
      return <FormCompress/>;
    case 4:
      return <FormTrim1/>;
    case 5:
      return <FormTrim2/>;
    case 6:
      return <FormAssembleFd/>;
    case 7:
      return <FormOutput/>;
    default:
      return 'Unknown step';
  }
  
}


export default FormFinal
